import { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";

const InvalidLink = ({ message, onRequestNew }) => (
  <div className="flex flex-col gap-4">
    <p data-testid="reset-password-error" className="text-sm font-semibold text-red-400">{message}</p>
    <button type="button" data-testid="reset-password-request-new" onClick={onRequestNew} className="ff-btn-primary w-full uppercase text-base">RICHIEDI NUOVO LINK</button>
  </div>
);

export const ResetPasswordDialog = ({ token, onClose, onDone }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [invalid, setInvalid] = useState("");
  const [checking, setChecking] = useState(false);
  const [loading, setLoading] = useState(false);
  const cleanToken = (token || "").trim();

  useEffect(() => {
    if (!cleanToken) {
      return;
    }
    setChecking(true);
    api.get("/auth/reset-password/check", { params: { token: cleanToken } })
      .then(({ data }) => setInvalid(data.valid ? "" : data.detail))
      .catch(() => setInvalid(""))
      .finally(() => setChecking(false));
  }, [cleanToken]);

  const requestNew = () => {
    onClose();
    onDone();
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token: cleanToken, password });
      toast.success("Password aggiornata: accedi con la nuova password");
      requestNew();
    } catch (err) {
      setError(apiError(err, "Reimpostazione non riuscita"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!token} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="reset-password-dialog" className="ff-glass-panel sm:max-w-md rounded-2xl p-5 sm:p-7">
        <DialogHeader className="text-left">
          <DialogTitle className="ff-display text-2xl font-extrabold flex items-center gap-2"><KeyRound size={22} className="text-[#10B981]" /> Nuova password</DialogTitle>
          <DialogDescription className="text-[#CBD5E1] text-sm">{checking ? "Verifica del link in corso…" : "Scegli una nuova password di almeno 8 caratteri."}</DialogDescription>
        </DialogHeader>
        {invalid ? <InvalidLink message={invalid} onRequestNew={requestNew} /> : (
          <form onSubmit={submit} className="flex flex-col gap-4">
            <input type="password" required minLength={8} autoComplete="new-password" data-testid="reset-password-input" className="ff-field" placeholder="Nuova password" value={password} onChange={(e) => setPassword(e.target.value)} />
            {error && <p data-testid="reset-password-error" className="text-sm font-semibold text-red-400">{error}</p>}
            <button type="submit" disabled={loading || checking} data-testid="reset-password-submit" className="ff-btn-primary w-full uppercase text-base">{loading ? "Salvataggio…" : "SALVA NUOVA PASSWORD"}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
